import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { SmallDraggableTile } from './SmallDraggableTile.jsx';
import { EmptyDigestPlaceholder } from '../TileDigest/EmptyDigestPlaceholder.jsx';

const SmallTileListContainer = styled.div`
  display: flex;
`;

const SmallTileList = ({ tiles, columnId, columnNumber }) => (
  <SmallTileListContainer>
    {tiles.length > 0 ? (
      tiles.map((tile, index) => (
        <SmallDraggableTile key={tile.id} index={index} {...tile} />
      ))
    ) : (
      <EmptyDigestPlaceholder columnNumber={columnNumber} columnId={columnId} />
    )}
  </SmallTileListContainer>
);

SmallTileList.propTypes = {
  tiles: PropTypes.array,
  columnId: PropTypes.string,
  columnNumber: PropTypes.number,
};

export { SmallTileList };
